<template>
    <!--公告预览-->
    <div class="page-wrap">
        <div class="title">
            {{notice.title}}
        </div>
        <div class="meta">
            <span class="store-name">{{notice.store_name}}</span>
            <span class="date-time">{{notice.create_datetime}}</span>
        </div>
        <div class="content" v-html="notice.content"></div>
    </div>
</template>

<script>
    export default {
        name: "NoticeShow",
        props: {
            id: {
                type: [String, Number],
                default: 0
            }
        },
        data(){
            return {
                notice: {}
            };
        },
        mounted(){
            this.$root.log(this.id);
            this.loadNoticeData();
        },
        methods: {
            loadNoticeData(){
                this.$root.postData("store_notice/get_data", {id: this.id}, res => {
                    if(res.errcode === 0)
                        this.notice = res.data;
                });
            }
        }
    }
</script>

<style scoped>
    .page-wrap{
        max-width: 677px;
        margin: 0 auto;
        padding-top: 32px;
        background-color: #FFFFFF;
    }
    .page-wrap .title{
        font-size: 22px;
        line-height: 1.4;
        margin-bottom: 14px;
    }
    .page-wrap .meta{
        display: inline-block;
        vertical-align: middle;
        margin: 0 10px 10px 0;
        font-size: 15px;
    }
    .meta .store-name{
        color: #576b95;
        margin-right: 10px;
    }
    .content{
        overflow: hidden;
        color: #333;
        font-size: 17px;
        position: relative;
        z-index: 0;
    }
</style>
